/*
 * Duallys Only: Hover secondary image on collection product cards
 *
 * Some collection pages (Wheels and Packages) are intended to show the
 * product's second image when a customer hovers over the card. This
 * behavior is built into the Dawn theme via CSS on `.card-wrapper:hover`
 * when the second image is present, but recent modifications and
 * overrides prevented the effect from working consistently on these
 * specific collections. To restore the hover transition without
 * affecting other collections, this script explicitly toggles the
 * first and second images' opacity on hover for products within the
 * Wheels and Packages collections.
 *
 * The script runs after the DOM has loaded. It first checks the
 * current URL path to confirm the visitor is browsing either the
 * `/collections/wheels` or `/collections/packages` pages. If not, the
 * function exits early, leaving all other collections untouched.
 *
 * It then selects each product card wrapper and looks for a
 * `.media--hover-effect` container with at least two `<img>` tags.
 * When found, listeners for `mouseenter` and `mouseleave` toggle
 * the opacity of the images. Scaling the second image on hover
 * reproduces Dawn’s built‑in zoom effect.
 */

// Immediately‑invoked function expression to avoid polluting the
// global scope. This module attaches hover handlers to product
// cards on the Wheels and Packages collections (and corresponding
// search pages) so that the secondary image appears on hover. It
// uses event delegation to handle cards added dynamically when
// filtering by vehicle.

(function () {
  function isRelevantPage() {
    try {
      var path = window.location.pathname;
      var params = new URLSearchParams(window.location.search);
      var cat = params.get('cat');
      // Apply to collection pages for wheels/packages and search pages
      // with a matching `cat` parameter. Use includes() so it matches
      // paginated URLs like `/collections/wheels?page=2`.
      return (
        path.includes('/collections/wheels') ||
        path.includes('/collections/packages') ||
        (path.includes('/search') && (cat === 'wheels' || cat === 'packages'))
      );
    } catch (err) {
      return false;
    }
  }

  if (!isRelevantPage()) {
    return;
  }

  // Helper to find the card wrapper containing the event target
  function findCardWrapper(target) {
    return target.closest('.card-wrapper');
  }

  function handleMouseOver(e) {
    var card = findCardWrapper(e.target);
    if (!card) return;
    var media = card.querySelector('.media.media--hover-effect');
    if (!media) return;
    var imgs = media.querySelectorAll('img');
    if (imgs.length < 2) return;
    imgs[0].style.opacity = '0';
    imgs[1].style.opacity = '1';
    imgs[1].style.transform = 'scale(1.03)';
  }

  function handleMouseOut(e) {
    var card = findCardWrapper(e.target);
    if (!card) return;
    // Only revert the hover effect when the mouse truly leaves the card.
    // The `relatedTarget` is the element that the cursor entered after
    // leaving the current element. If it is still inside the same card
    // wrapper, ignore this event so the effect persists while hovering
    // over child elements (like badges or icons).
    if (card.contains(e.relatedTarget)) return;
    var media = card.querySelector('.media.media--hover-effect');
    if (!media) return;
    var imgs = media.querySelectorAll('img');
    if (imgs.length < 2) return;
    imgs[0].style.opacity = '';
    imgs[1].style.opacity = '';
    imgs[1].style.transform = '';
  }

  // Use event delegation so the handlers apply to cards added later
  document.addEventListener('mouseover', handleMouseOver);
  document.addEventListener('mouseout', handleMouseOut);
})();